import React, {Children, cloneElement} from 'react'
import FieldLabel from './FieldLabel'
import FieldMessage from './FieldMessage'

const FormField = ({value, name, onChange, label, children, errors}) => {
  const normalizedChildren = Children.map(children, child => {
    if (child) {
      return cloneElement(child, {
        value,
        name,
        onChange
      })
    }
    return child
  })

  return (
    <>
      <FieldLabel htmlFor={name}>{label}</FieldLabel>
      {normalizedChildren}
      <FieldMessage errors={errors} fieldName={name} />
    </>
  )
}

export default FormField
